import Coords from '../Util/Coords';

const TrigFnCached = {
    "sin": [0, Math.sin(Math.PI/3), Math.sin(Math.PI/3), 0, -Math.sin(Math.PI/3), -Math.sin(Math.PI/3)],
    "cos": [1, 0.5, -0.5, -1, -0.5, 0.5]
};

export default class GridMode {

    constructor() {
        this.width = 0;
        this.height = 0;
        this.centerX = 0;
        this.centerY = 0;
        this.viewCenter = [0,0];
        this.viewSize = [0,0];
        this.tileSize = 70;
        this.tileCenter = 35;
        this.lookingAt = [0,0];
        this.mode = 'square';
    }

    setHeight(h) {
        this.height = h;
        this.centerY = h/2;
        this.viewSize[1] = h;
        this.viewCenter[1] = h/2;
    }

    setWidth(w) {
        this.width = w;
        this.centerX = w/2;
        this.viewSize[0] = w;
        this.viewCenter[0] = w/2;
    }

    setLookingAt(lookingAt) {
        this.lookingAt = lookingAt;
    }

    setTileSize(tileSize) {
        this.tileSize = tileSize;
        this.tileCenter = tileSize / 2;
    }

    setMode(mode) {
        this.mode = mode;
    }

    drawHex(ctx, xScreen, yScreen) {
        ctx.beginPath();
        for(let i=0; i<6; i++) {
            ctx.lineTo(
                xScreen + this.tileCenter * TrigFnCached.cos[i], 
                yScreen + this.tileCenter * TrigFnCached.sin[i]
            );
        }
        ctx.closePath();
        ctx.stroke();
    }

    drawSquare(ctx) {
        let available = [0,0].map((a,i) => Math.ceil(((this.viewSize[i] / this.tileSize) + 2) / 2));

        ctx.strokeStyle = "rgba(255,255,255, 0.1)";
        for (let i=-available[0]; i<available[0]; i++) {
            for (let j=-available[1]; j<available[1]; j++) {
                let point = [i,j].map((a,i) => Math.round(a + this.lookingAt[i]));
                let centerSquare = Coords.toView(point, this.viewCenter, this.lookingAt, this.tileSize);
                ctx.strokeRect(centerSquare[0]-this.tileCenter, centerSquare[1]-this.tileCenter, this.tileSize, this.tileSize);
            }
        }
        
        ctx.textAlign = "center";
        ctx.font = '10px sans-serif';
        ctx.strokeStyle = "#000";
        ctx.fillStyle = "#fff";
        ctx.lineWidth = 2;

        for (let i=-available[0]; i<available[0]; i++) {
            let col = Math.round(i + this.lookingAt[0]);
            let pView = Coords.toView([col, 0], this.viewCenter, this.lookingAt, this.tileSize);

            ctx.strokeText(String(col), pView[0], 10);
            ctx.fillText(String(col), pView[0], 10);
        }

        ctx.textAlign = "left";

        for (let j=-available[1]; j<available[1]; j++) {
            let row = Math.round(j + this.lookingAt[1]);
            let pView = Coords.toView([0, row], this.viewCenter, this.lookingAt, this.tileSize);

            ctx.strokeText(String(row), 0, pView[1]+5);
            ctx.fillText(String(row), 0, pView[1]+5);
        }

        // Draw view center
        let centerLooking = Coords.toView(this.lookingAt, this.viewCenter, this.lookingAt, this.tileSize);
        ctx.strokeStyle = "#3af";
        ctx.beginPath();
        ctx.moveTo(centerLooking[0] - 5, centerLooking[1]);
        ctx.lineTo(centerLooking[0] + 5, centerLooking[1]);
        ctx.moveTo(centerLooking[0], centerLooking[1] - 5);
        ctx.lineTo(centerLooking[0], centerLooking[1] + 5);
        ctx.stroke();

        // Draw world center
        let centerWorld = Coords.toView([0,0], this.viewCenter, this.lookingAt, this.tileSize);
        ctx.strokeStyle = "#f33";
        ctx.beginPath();
        ctx.moveTo(centerWorld[0] - 5, centerWorld[1]);
        ctx.lineTo(centerWorld[0] + 5, centerWorld[1]);
        ctx.moveTo(centerWorld[0], centerWorld[1] - 5);
        ctx.lineTo(centerWorld[0], centerWorld[1] + 5);
        ctx.stroke();
    }


    drawHexagon(ctx) {
        let available = [0,0].map((a,i) => Math.ceil((this.viewSize[i] / this.tileSize) + 2));

        ctx.lineWidth = 1;
        ctx.strokeStyle = "rgba(255,255,255, 0.1)";
        ctx.textAlign = "center";
        ctx.fillStyle = "#fff";
        ctx.font = '10px sans-serif';

        for (let i=-available[0]; i<available[0]; i++) {
            for (let j=-available[1]; j<available[1]; j++) {
                let point = [i,j].map((a,i) => Math.round(a + this.lookingAt[i]));
                let centerHex = Coords.toViewHex(point, this.viewCenter, this.lookingAt, this.tileSize);
                this.drawHex(ctx, centerHex[0], centerHex[1]);
            }
        }

        ctx.lineWidth = 2;

        // Draw view center
        let centerLooking = Coords.toView(this.lookingAt, this.viewCenter, this.lookingAt, this.tileSize);
        ctx.strokeStyle = "#3af";
        ctx.beginPath();
        ctx.moveTo(centerLooking[0] - 5, centerLooking[1]);
        ctx.lineTo(centerLooking[0] + 5, centerLooking[1]);
        ctx.moveTo(centerLooking[0], centerLooking[1] - 5);
        ctx.lineTo(centerLooking[0], centerLooking[1] + 5);
        ctx.stroke();

        // Draw world center
        let centerWorld = Coords.toViewHex([0,0], this.viewCenter, this.lookingAt, this.tileSize);
        ctx.strokeStyle = "#f33";
        ctx.beginPath();
        ctx.moveTo(centerWorld[0] - 5, centerWorld[1]);
        ctx.lineTo(centerWorld[0] + 5, centerWorld[1]);
        ctx.moveTo(centerWorld[0], centerWorld[1] - 5);
        ctx.lineTo(centerWorld[0], centerWorld[1] + 5);
        ctx.stroke();
    }


    draw(ctx) {
        if (this.mode === 'hexagon') {
            this.drawHexagon(ctx);
        } else {
            this.drawSquare(ctx);
        }
    }

}